// Module
var code = "<h3 id=\"terimler\">Terimler</h3> <p><a href=\"index.md\">İndexe Geri Git</a></p> ";
// Exports
export default code;